var render = function () {
  var _vm$row, _vm$row2, _vm$row3, _vm$row4, _vm$row5, _vm$row7, _vm$row9, _vm$row10, _vm$row11, _vm$row12, _vm$row13;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "ok-disabled": _vm.formSubmitted,
      "id": "uploadFileModal",
      "centered": true,
      "title": _vm.modalTitle,
      "hide-footer": true,
      "size": "lg",
      "hide-header-close": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.getPolicyDetails,
      "hidden": function hidden($event) {
        return _vm.hideModal();
      }
    }
  }, [_c('b-button', {
    staticClass: "btn-container",
    attrs: {
      "variant": "close-btn"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _c('form', [_c('label', {
    staticClass: " font-bold modal-label-prudential",
    attrs: {
      "for": "plan"
    }
  }, [_vm._v(" " + _vm._s(((_vm$row = _vm.row) === null || _vm$row === void 0 ? void 0 : _vm$row.status) === "submitted" ? "Selected Plan" : "Select Plan") + " ")]), _c('span', {
    staticClass: "input-required"
  }, [_vm._v("*")]), _c('br'), _c('div', {
    staticClass: "wrapper modal-label-prudential  mb-2 pb-1"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": "Select Plan",
      "options": _vm.plan_details,
      "disabled": ((_vm$row2 = _vm.row) === null || _vm$row2 === void 0 ? void 0 : _vm$row2.status) === 'submitted',
      "track-by": "plan_id",
      "label": "plan_name"
    },
    model: {
      value: _vm.form.plan_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "plan_id", $$v);
      },
      expression: "form.plan_id"
    }
  })], 1), _vm.showError('plan_id') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" Please select a plan ")]) : _vm._e(), _c('label', {
    staticClass: "modal-label-prudential",
    attrs: {
      "for": "file"
    }
  }, [_vm._v(_vm._s(_vm.fileLabel) + " ")]), ((_vm$row3 = _vm.row) === null || _vm$row3 === void 0 ? void 0 : _vm$row3.status) !== 'submitted' ? [_c('span', {
    staticClass: "input-required"
  }, [_vm._v(" * ")]), _c('br'), _c('input', {
    ref: "fileInput",
    staticClass: "w-100 mb-3",
    attrs: {
      "type": "file",
      "id": "fileInput",
      "name": "fileInput",
      "multiple": "",
      "disabled": ((_vm$row4 = _vm.row) === null || _vm$row4 === void 0 ? void 0 : _vm$row4.status) === 'submitted'
    },
    on: {
      "change": _vm.fileSelected
    }
  }), _c('button', {
    staticClass: "choose-file-btn",
    attrs: {
      "type": "button",
      "disabled": ((_vm$row5 = _vm.row) === null || _vm$row5 === void 0 ? void 0 : _vm$row5.status) === 'submitted'
    },
    on: {
      "click": _vm.triggerFileInput
    }
  }, [_vm._v(" Drop files here or \"Browse\" ")]), _vm.showError('files') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" Please Upload file ")]) : _vm._e()] : _vm._e(), _c('div', {
    staticClass: "d-flex flex-wrap"
  }, _vm._l(_vm.form.files, function (file, index) {
    var _vm$row6;

    return _c('div', {
      key: "".concat(file.name, "-").concat(index),
      staticClass: "mb-2 file-name-wrap file-name-list pl-2 pb-1"
    }, [_c('span', {
      staticClass: "pr-3 "
    }, [_vm._v(_vm._s(file.name))]), ((_vm$row6 = _vm.row) === null || _vm$row6 === void 0 ? void 0 : _vm$row6.status) !== 'submitted' ? _c('div', {
      staticClass: "close-icon",
      on: {
        "click": function click($event) {
          return _vm.removeFile(index);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-times ml-2"
    })]) : _vm._e()]);
  }), 0), ((_vm$row7 = _vm.row) === null || _vm$row7 === void 0 ? void 0 : _vm$row7.status) == 'submitted' && _vm.form.file_lists && _vm.form.file_lists.length > 0 ? [_c('div', {
    staticClass: "d-flex flex-wrap"
  }, _vm._l(_vm.form.file_lists, function (file) {
    var _vm$row8;

    return _c('div', {
      key: "".concat(file.filename),
      staticClass: "mb-2 pl-2 file-name-wrap pb-1"
    }, [((_vm$row8 = _vm.row) === null || _vm$row8 === void 0 ? void 0 : _vm$row8.status) == 'submitted' ? _c('a', {
      staticClass: "clr-active",
      attrs: {
        "href": file.filepath,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "pr-3 pb-4"
    }, [_vm._v(_vm._s(file.filename))])]) : _c('span', {
      staticClass: "pr-3 "
    }, [_vm._v(_vm._s(file.filename))]), _c('div', {
      staticClass: "close-icon",
      on: {
        "click": function click($event) {
          return _vm.downloadFile(file.filepath);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-download ml-2",
      staticStyle: {
        "font-size": "10px",
        "position": "absolute",
        "top": "5px",
        "left": "5px"
      }
    })])]);
  }), 0)] : _vm._e(), _vm.isEdit && ((_vm$row9 = _vm.row) === null || _vm$row9 === void 0 ? void 0 : _vm$row9.status) !== 'submitted' && _vm.form.file_lists && _vm.form.file_lists.length > 0 ? [_c('div', {
    staticClass: "d-flex flex-wrap edit-icon"
  }, _vm._l(_vm.form.file_lists, function (file, index) {
    return _c('div', {
      key: "".concat(file.filename),
      staticClass: "mb-2 pl-2 file-name-wrap pb-1"
    }, [_c('span', {
      staticClass: "pr-3"
    }, [_vm._v(_vm._s(file.filename) + " ")]), _c('i', {
      staticClass: "fas fa-download ml-2 close-icon",
      staticStyle: {
        "font-size": "10px",
        "position": "absolute",
        "top": "5px",
        "right": "22px"
      },
      on: {
        "click": function click($event) {
          return _vm.downloadFile(file.filepath);
        }
      }
    }), _c('i', {
      staticClass: "fas fa-times ml-2 close-icon",
      staticStyle: {
        "font-size": "10px",
        "position": "absolute",
        "top": "5px"
      },
      on: {
        "click": function click($event) {
          return _vm.removeFileLists(file.id, index);
        }
      }
    })]);
  }), 0)] : _vm._e(), ((_vm$row10 = _vm.row) === null || _vm$row10 === void 0 ? void 0 : _vm$row10.status) === 'submitted' && _vm.form.description ? [_c('label', {
    staticClass: "modal-label-prudential mt-2 mb-1",
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Remarks:")]), _c('br'), ((_vm$row11 = _vm.row) === null || _vm$row11 === void 0 ? void 0 : _vm$row11.status) === 'submitted' ? _c('p', [_vm._v(_vm._s(_vm.form.description))]) : _vm._e()] : ((_vm$row12 = _vm.row) === null || _vm$row12 === void 0 ? void 0 : _vm$row12.status) !== 'submitted' ? [_c('label', {
    staticClass: "modal-label-prudential",
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Remarks:")]), _c('br'), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.description,
      expression: "form.description"
    }],
    staticClass: "w-100 form-text-desc",
    attrs: {
      "rows": "6"
    },
    domProps: {
      "value": _vm.form.description
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.form, "description", $event.target.value);
      }
    }
  })] : _vm._e(), ((_vm$row13 = _vm.row) === null || _vm$row13 === void 0 ? void 0 : _vm$row13.status) !== 'submitted' ? _c('div', {
    staticClass: "submit-btn upload-submit"
  }, [_c('button', {
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.submitFiles.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "Update" : "Submit") + " ")])]) : _vm._e()], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }